// src/pages/ViewReminders.jsx
import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import languageContext from "../context/language/languageContext";
import Navbar from "../components/Navbar";
import { Bell, Calendar, Clock, AlarmCheck } from "lucide-react";
import { useLocation } from "react-router-dom";

const ViewReminders = () => {
  const { setAlert, setMessage, setSessionTimeout } = useContext(languageContext);
  const [reminders, setReminders] = useState([]);
  const location = useLocation();

  const fetchReminders = async () => {
    const patient_id = location.state?.patient_id;
    if (!patient_id) return;
    try {
      const response = await axios.post("https://www.careplus.gopillz.com/all_reminder", 
      JSON.stringify({ id: patient_id }),
      {
        headers: {
            Accept: "*/*",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      });

      if (response.status === 200) {
        setReminders(response.data.data || []);
      }
    } catch (error) {
      if (error.response?.data?.detail === "Token has expired") {
        setSessionTimeout(true);
      } else {
        setAlert(true);
        setMessage("Failed to fetch reminders. Try again later.");
        console.error(error);
      }
    }
  };

  const getReminderTypeLabel = (type) => {
    if (type.toLowerCase() === "am") return "Morning";
    if (type.toLowerCase() === "pm") return "Evening";
    if (type.toLowerCase()==="nt") return "Night";
    return type;
  };

  useEffect(() => {
    fetchReminders();
  }, []);

  
  return (
    <div className="flex flex-col min-h-screen bg-gradient-to-br from-blue-50 to-white">
      <Navbar />

      <div className="p-6 max-w-6xl mx-auto w-full">
        <h2 className="text-3xl font-bold text-blue-900 mb-8 text-center">
          🔔 Patient Reminders
        </h2>

        {reminders.length === 0 ? (
          <div className="text-center text-gray-500 italic py-10">
            No reminders available.
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {reminders.map((reminder) => (
              <div
                key={reminder.id}
                className="bg-white shadow-md rounded-2xl p-5 border border-blue-100 hover:shadow-xl transition duration-300"
              >
                <div className="flex items-center gap-3 mb-3">
                  <Bell className="text-blue-600 w-5 h-5" />
                  <h3 className="text-lg font-semibold text-blue-800">
                    {reminder.medicine_name}
                  </h3>
                </div>

                <div className="flex items-center text-sm text-gray-600 mb-1">
                  <Calendar className="w-4 h-4 mr-2" />
                  <span>
                    {reminder.start_date} - {reminder.end_date}
                  </span>
                </div>

                <div className="flex items-center text-sm text-gray-600 mb-1">
                  <Clock className="w-4 h-4 mr-2" />
                  <span>{reminder.time} ({getReminderTypeLabel(reminder.reminder_type)})</span>
                </div>

                <div className="mt-2 text-sm text-gray-700">
                  <strong>Days:</strong> {reminder.reminder_day.join(", ")}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ViewReminders;